import React from "react";
import type { RouteObject } from "react-router-dom";
import { LandingScreen } from "./pages/landing-screen/landing-screen";

export const routesResource: RouteObject[] = [
  { path: "landing", index: true, element: <LandingScreen /> },
  { path: "page1", element: <div>page1</div> },
  { path: "page2", element: <div>page2</div> },
];
